import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, FieldErrorAndDescription, FieldLabel } from '@systemeio/ui';
import { GoogleCalendarSelector } from 'modules/profile/integrations/google/calendar-selector';
import { useCalendars } from 'modules/profile/integrations/google/hooks/use-calendars';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { EventLocationTypeEnum } from '../constants';
import { EventLocationInterface } from '../types/event-interface';
interface Props {
  locations: EventLocationInterface[];
  googleCalendarId?: string;
  googleIntegrationId?: string;
  googleCalendarError?: string;
  googleIntegrationError?: string;
  setGoogleCalendarId: (id: string | undefined) => void;
  setGoogleIntegrationId: (id: string | undefined) => void;
}
export function AddToGoogleCalendar(t0) {
  const $ = _c(39);
  const {
    locations,
    googleCalendarId,
    googleIntegrationId,
    googleCalendarError,
    googleIntegrationError,
    setGoogleCalendarId,
    setGoogleIntegrationId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [switchState, setSwitchState] = useState(!!googleCalendarId);
  const {
    hasGoogleCalendars,
    data: calendars
  } = useCalendars();
  const isGoogleMeetInLocations = !!locations?.length && locations.some(_temp);
  const addToGoogleCalendarSelected = switchState || isGoogleMeetInLocations;
  let t1;
  let t2;
  if ($[0] !== googleCalendarId) {
    t1 = () => {
      if (googleCalendarId) {
        setSwitchState(true);
      }
    };
    t2 = [googleCalendarId];
    $[0] = googleCalendarId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  useLayoutEffect(() => {
    if (addToGoogleCalendarSelected && !googleCalendarId && hasGoogleCalendars && calendars) {
      const defaultCalendar = calendars.find(_temp2);
      setGoogleCalendarId(defaultCalendar?.id);
      setGoogleIntegrationId(defaultCalendar?.integration.id);
    }
  }, [addToGoogleCalendarSelected]);
  if (!hasGoogleCalendars) {
    return null;
  }
  let t3;
  if ($[3] !== calendars || $[4] !== googleCalendarId || $[5] !== googleIntegrationId) {
    t3 = calendars?.find(calendar_0 => calendar_0.id === googleCalendarId && calendar_0.integration.id === googleIntegrationId);
    $[3] = calendars;
    $[4] = googleCalendarId;
    $[5] = googleIntegrationId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const selectedCalendar = t3;
  const t4 = "flex flex-col gap-3";
  let t5;
  if ($[7] !== t) {
    t5 = t("dashboard.user_settings.integrations_page.google_calendar.name");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <FieldLabel label={t5} />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const T0 = CheckBoxSwitcher;
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.calendar.add_event_to_google_calendar");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = twMerge(isGoogleMeetInLocations && "cursor-not-allowed");
  let t9;
  if ($[13] !== setGoogleCalendarId || $[14] !== setGoogleIntegrationId) {
    t9 = value => {
      setSwitchState(value);
      if (!value) {
        setGoogleCalendarId(undefined);
        setGoogleIntegrationId(undefined);
      }
    };
    $[13] = setGoogleCalendarId;
    $[14] = setGoogleIntegrationId;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== T0 || $[17] !== addToGoogleCalendarSelected || $[18] !== isGoogleMeetInLocations || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <T0 label={t7} selected={addToGoogleCalendarSelected} disabled={isGoogleMeetInLocations} switcherClassName={t8} onChange={t9} />;
    $[16] = T0;
    $[17] = addToGoogleCalendarSelected;
    $[18] = isGoogleMeetInLocations;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== addToGoogleCalendarSelected || $[24] !== selectedCalendar || $[25] !== setGoogleCalendarId || $[26] !== setGoogleIntegrationId || $[27] !== t) {
    t11 = addToGoogleCalendarSelected && <GoogleCalendarSelector label={t("dashboard.calendar.select_calendar")} calendar={selectedCalendar} onChange={(calendarId, integrationId) => {
      setGoogleCalendarId(calendarId);
      setGoogleIntegrationId(integrationId);
    }} className="max-w-xl" />;
    $[23] = addToGoogleCalendarSelected;
    $[24] = selectedCalendar;
    $[25] = setGoogleCalendarId;
    $[26] = setGoogleIntegrationId;
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== googleCalendarError) {
    t12 = <FieldErrorAndDescription error={googleCalendarError} />;
    $[29] = googleCalendarError;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== googleIntegrationError) {
    t13 = <FieldErrorAndDescription error={googleIntegrationError} />;
    $[31] = googleIntegrationError;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13 || $[37] !== t6) {
    t14 = <div className={t4}>{t6}{t10}{t11}{t12}{t13}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t6;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
function _temp2(calendar) {
  return calendar.isUsedForSync;
}
function _temp(location) {
  return location.locationType === EventLocationTypeEnum.GoogleMeet;
}